module.exports = __webpack_public_path__ + "static/media/ufo.402db94e.svg";